// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"ebf08f4d","273":"ea14afca","999":"c9eec6cc"}[chunkId] + ".chunk.js";
};